import { createSlice }          from '@reduxjs/toolkit';
import * as eventTicketReducers from 'Redux/Reducers/EventTicket';
import { EventTicket }          from 'Domain/Models';

export interface IEventTicketState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, EventTicket>,
  lastUpdateId: string | null,
  maxCount: number,
}

export const eventTicketSlice = createSlice({
  name: 'eventTicket',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
  },
  reducers: eventTicketReducers,
});
